export default [
  {
    name: 'Schedule.ScheduleCreate',
    path: 'create',
    component: () => import('./components/manage/ScheduleCreate'),
    meta: { wide: true }
  },
  {
    name: 'Schedule.ScheduleAssign',
    path: 'assign',
    component: () => import('./components/manage/ScheduleAssign'),
    meta: { wide: true }
  }
]
